import { render, staticRenderFns } from "./signed.vue?vue&type=template&id=57ac23ad&scoped=true&"
import script from "./signed.vue?vue&type=script&lang=js&"
export * from "./signed.vue?vue&type=script&lang=js&"
import style0 from "./signed.vue?vue&type=style&index=0&id=57ac23ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ac23ad",
  null
  
)

export default component.exports